import { useFormikContext } from "formik";
import React from "react";
import UploadMedia from "../../../../../components/features/UploadMedia";
import { Template } from "../../../../../models";

export default function UploadMediaInput() {
  const { values, errors, setFieldValue, setErrors } =
    useFormikContext<Partial<Template>>();
  return (
    <UploadMedia
      url={values.uploadMediaUrl ?? ""}
      error={errors?.uploadMediaUrl as string}
      onUpload={(value) => {
        setFieldValue("uploadMediaUrl", value);
        // handle resetting auto fields as UPLOAD is one-off
        if (values?.isAutoEnabled) {
          setFieldValue("isAutoEnabled", false);
          setFieldValue("autoDays", []);
          setFieldValue("username", null);
          setFieldValue("autoTime1", null);
          setFieldValue("autoTime2", null);
          setFieldValue("externalUserId", null);
        }
      }}
      onError={(message: string) => setErrors({ uploadMediaUrl: message })}
    />
  );
}
